// client/src/components/auth/profile/AboutSection.js
import React, { useState, useEffect } from 'react'
import FloatingTextarea from './FloatingTextarea'
import addRipple from '../../../utils/ripple'
import '../../../styles/profileFields.css'

function AboutSection({
  playerData,
  onPlayerDataChange,
  isEditing,
  onEditClick,
  editingField,
  onInlineSave,
  onInlineCancel,
}) {
  const [formData, setFormData] = useState({
    bio: playerData?.bio || '',
  })

  // Update form data when playerData changes or isEditing changes
  useEffect(() => {
    if (playerData) {
      setFormData({
        bio: playerData.bio || '',
      })
    } else {
      setFormData({ bio: '' })
    }
  }, [playerData, isEditing])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    const newLocalFormData = { ...formData, [name]: value }
    setFormData(newLocalFormData)
    onPlayerDataChange(newLocalFormData) // Call onPlayerDataChange after local state update
  }

  const isFieldEditing = isEditing && editingField === 'bio'
  return (
    <div className="profile-card">
      <h5 className="section-title">✍️ About Me</h5>
      {!isFieldEditing && (
        <button
          type="button"
          className="field-chip full-width"
          onClick={(e) => {
            addRipple(e)
            onEditClick('bio')
          }}
        >
          <span className="chip-label">Bio</span>
          <span className="chip-value">
            {formData.bio?.trim() || 'Add a short bio…'}
          </span>
        </button>
      )}
      {isFieldEditing && (
        <div className="field-chip editing full-width">
          <span className="chip-label">Bio</span>
          <div className="chip-editor">
            <FloatingTextarea
              label="Bio"
              name="bio"
              value={formData.bio}
              onChange={handleInputChange}
              placeholder="Share a bit about yourself as a tennis player..."
              rows={3}
              disabled={!isFieldEditing}
            />
            <div className="chip-actions">
              <button
                type="button"
                className="icon-btn confirm"
                onClick={() => onInlineSave && onInlineSave('bio')}
              >
                ✓
              </button>
              <button
                type="button"
                className="icon-btn cancel"
                onClick={() => onInlineCancel && onInlineCancel('bio')}
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AboutSection
